// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"469b0ed3","943":"7db0d29b"}[chunkId] + ".chunk.js";
};